module.exports = "/remote-dist/17284ea8d3272f04e3c8ebd3b999be2c.png";